// Configuration des entreprises partenaires
export interface CompanyConfig {
  id: string;
  name: string;
  emailDomains: string[];
  theme?: {
    primaryColor?: string;
    secondaryColor?: string;
  };
  features?: {
    hasInsurance?: boolean;
    hasSpecialActions?: boolean;
  };
}

export const COMPANIES: Record<string, CompanyConfig> = {
  legrand: {
    id: 'legrand',
    name: 'Legrand',
    emailDomains: ['legrand.com', 'legrand.fr'],
    theme: {
      primaryColor: '#2196f3',
      secondaryColor: '#f50057'
    },
    features: {
      hasInsurance: true,
      hasSpecialActions: true
    }
  },
  kuoni: {
    id: 'kuoni',
    name: 'Kuoni',
    emailDomains: ['kuoni.com', 'kuoni.fr'],
    theme: {
      primaryColor: '#ff6b00',
      secondaryColor: '#004080'
    },
    features: {
      hasInsurance: true,
      hasSpecialActions: true
    }
  },
  // Ajouter d'autres entreprises ici
};

// Récupérer la configuration de l'entreprise courante
export const getCurrentCompany = (): CompanyConfig | null => {
  const company = process.env.REACT_APP_COMPANY;
  if (!company || company === 'default') {
    return null; // Admin standard
  }
  return COMPANIES[company] || null;
};

// Vérifier si on est dans un contexte d'entreprise
export const isCompanyMode = (): boolean => {
  return getCurrentCompany() !== null;
};

// Obtenir le nom de l'entreprise courante
export const getCompanyName = (): string => {
  const company = getCurrentCompany();
  return company?.name || 'Admin';
};

// Obtenir les domaines email autorisés
export const getCompanyEmailDomains = (): string[] => {
  const company = getCurrentCompany();
  return company?.emailDomains || [];
};